﻿import { VueReCaptcha } from "vue-recaptcha-v3"
import Vue from "vue";
import Component from "vue-class-component";
import HotEditableFormManager_ from "./hotEditable/HotEditableFormManager";
import common from "../../common";
import SharedFormManager_ from "./hotEditable/SharedFormManager";
import HotEditableFormLoader_ from "./hotEditable/HotEditableFormLoader";
import utilities_ from "../utilities";
import context_ from "../context";

declare function require(module: string): unknown;
const utilities = require("../utilities") as typeof utilities_;
const context = require("../context") as typeof context_;
// const HotEditableFormManager = require("./hotEditable/HotEditableFormManager") as HotEditableFormManager_;
// const SharedFormManager = require("./hotEditable/SharedFormManager") as SharedFormManager_;
// const HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader") as HotEditableFormLoader_;

@Component
class RecaptchaSecuriteVue extends Vue implements common.IHotEditableFormVue {
    shared?: SharedFormManager_;
    formMode = common.HotEditableFormModes.original;
    formManager?: HotEditableFormManager_ | null;
    culture?: common.Cultures;
    isVisibleLanguage?: boolean;
    isVisibleToggleButton = false;
    forceUpdate = "1";
    initTrigger = '';
    bag = {} as any;
    _bagTmp: any;
    _initialConcurrencySumCheck?: string | null;
    _manageButtonsOnFormModeChange?: boolean;
    /** Doit etre meme que WebConstants */
    _recaptchaAction?: string;
    _lastBagTimemoutId = null as ReturnType<typeof setTimeout> | null;
    _initCulture = null as string | null;
    _onCultureChangeCallback = null as ((culture: common.Cultures) => void) | null;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        const initialConcurrencySumCheck = (this as any).$initialData.concurrencySumCheck as string || null;
        const includesConcurrencySumCheck = (this as any).$initialData.includesConcurrencySumCheck as boolean || !!initialConcurrencySumCheck;
        HotEditableFormLoader_.prepareComponentsMarkupFromTarget(true, includesConcurrencySumCheck, rootId).loadComponentsFromParent(this);

        this._initialConcurrencySumCheck = initialConcurrencySumCheck;
        this._initCulture = (this as any).$initialData.currentCulture as common.Cultures;
        this._bagTmp = (this as any).$initialData.bag || {};
        this.culture = context.culture.get();
        this._recaptchaAction = (this as any).$initialData.recaptchaAction || null;
        this.$options.el = '#' + rootId;

        this.formManager = new HotEditableFormManager_(this, (this as any).$initialData.formName as string | null, {
            loadFormModeFromUrl: (this as any).$initialData.loadFormModeFromUrl !== false,
            embeddedContentModels: (((this as any).$initialData.embeddedContentModels || []) as common.IEmbeddedContentModel[]).sort((a, b) => {
                return (a?.order ?? 0) - (b?.order ?? 0);
            })
        });
        this.shared = new SharedFormManager_(this.formManager);

        // reCAPTCHA v3 official language code
        const rcLanguageCodes = {} as any;
        rcLanguageCodes[common.Cultures.fr] = 'fr';
        rcLanguageCodes[common.Cultures.en] = 'en';
        var rcLanguageCode = rcLanguageCodes[this.culture ?? common.Cultures.fr];
        Vue.use(VueReCaptcha, {
            siteKey: context.reCaptcha?.siteKey,
            // /** ReCaptcha v3 options => https://github.com/AurityLab/recaptcha-v3/#load-options-usage */
            loaderOptions: {
                renderParameters: {
                    hl: rcLanguageCode
                },
                //     /** The container if you want to render the inline widget */
                //     container: null as string | Element,
                //     /** The positioning for the widget */
                //     badge: null as string,//'bottomright' or 'bottomleft' or 'inline'
                //     /** The size of the widget */
                //     size: null as string,//'invisible'
                //     /** The tab index of the widget */
                //     tabindex: null as number
            }
        });

        (this as any).$options.components["vue-recaptcha"] = VueReCaptcha;
    }
    closeReCaptcha() {
        if (this.$recaptchaInstance && (this.$recaptchaInstance as any).hideBadge)
            (this.$recaptchaInstance as any).hideBadge();
        return this;
    }
    destroyComponents() {
        this.formManager?.destroyComponents();
        this.formManager = null;//DESTROY (TEST)
        return this;
    }

    created() {
    }

    beforeMount() {
        this.initTrigger = "1";
    }

    mounted() {
        this.bag = this._bagTmp;

        if (!!this._initialConcurrencySumCheck)
            this.initConcurrencySumCheck(this._initialConcurrencySumCheck);
    }

    data() {
        const c = this._initCulture ? common.Cultures[this._initCulture as common.Cultures] ?? (() => { throw "La culture '" + this._initCulture + "' n'est pas supportée."; })() : common.Cultures.fr;
        const o = {
            culture: c,
            isVisibleLanguage: true
        };
        return o;
    }
    setOnCultureChangeCallback(callback: (culture: common.Cultures) => void) {
        this._onCultureChangeCallback = callback || (function () { throw "L'argument 'callback' est NULL."; })();
        return this;
    }
    onToggleCulture(event: Event) {
        event.preventDefault();
        this.toggleCulture();
    }
    toggleCulture() {
        this.updateCulture(this.culture === common.Cultures.en ? common.Cultures.fr : common.Cultures.en);
        return this;
    }
    /** Sequence: thisVue.updateCulture > callbak(post API & wait updatedCulture) > thisVue.setCulture */
    updateCulture(cultureName?: string) {
        cultureName = (cultureName || '').trim();
        const c = cultureName
            ? common.Cultures[cultureName as common.Cultures] || (function () { throw "La culture '" + cultureName + "' n'existe pas."; })()
            : common.Cultures.fr
        if (!this._onCultureChangeCallback)
            throw "Aucun callback configuré pour lors du changement de culture.";
        this._onCultureChangeCallback(c);
        return this;
    }
    setCutlure(culture: common.Cultures) {
        if (!culture)
            throw "L'argument 'callback' est NULL.";
        if (!common.Cultures[culture])
            throw "La culture '" + culture + "' n'existe pas.";
        this.culture = culture;
        return this;
    }
    /** Sequence: thisVue.updateCulture > update the culture context name > callbak(post API & wait updatedCulture) > thisVue.setCulture */
    refreshCultureFromContext() {
        this.setCutlure(context.culture.get());
        return this;
    }
    showCultureToggleButton(value?: boolean) {
        value = value !== false;
        this.isVisibleLanguage = value;
    }
    getBagRaw() {
        const r = utilities.serializeBag(this.bag || {});
        return r;
    }

    private onInit(initTrigger: string, action: () => void | string) {
        if (!initTrigger)
            return '';
        this.initTrigger = '';
        if (action)
            action();
        return action ? action() || '' : '';
    }

    updateBagOnInit(initTrigger: string, key: string, value?: any) {
        return this.onInit(initTrigger, () => {
            //this.setToBag(key, value);
            this._bagTmp[key] = value;
            return value;
        });
    }

    /** vue-recaptcha-v3@1.9.0 (https://github.com/AurityLab/vue-recaptcha-v3/tree/v1.9.0) */
    onNextButtonClick(event: Event, suffix?: string) {
        event.preventDefault();

        // (optional) Wait until recaptcha has been loaded.
        this.$recaptchaLoaded();

        // Execute reCAPTCHA with action
        if (!this._recaptchaAction) throw "Recaptcha : L'action doit être définie.";
        const token = this.$recaptcha(this._recaptchaAction);

        token.then(x => {
            const value = x + (!suffix ? '' : suffix);
            this.applyUpdate(value, common.HotEditableActionTypes.apply);
        });
    }

    applyUpdate(actionValue?: string, actionType?: common.HotEditableActionTypes) {
        this.formManager?.applyUpdate(actionValue, actionType);
        return this;
    }

    updateFieldTextualValue(fieldName: string, value?: string) {
        value = value || '';
        if (!fieldName)
            throw "L'argument 'fieldName' est requis.";
        const f = this.formManager?.getFieldByName(fieldName);
        if (f)
            f.setFromTextualValue(value);
        return this;
    }

    getFromBag(key: string) {
        const r = this.bag[key];
        return r || r === false || r === 0 || r === '' ? r : null;
    }

    getBooleanFromBag(key: string, defaultValue?: boolean) {
        const val = this.getFromBag(key);
        if (val === true || val === false)
            return val;
        return defaultValue ?? false;
    }

    setToBag(key: string, value?: any, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        delayMs = delayMs || 0;
        forceDelayedSetToBeExecuted = forceDelayedSetToBeExecuted === true;
        const f = () => { this.$set(this.bag, key, value || value === false || value === 0 || value === '' ? value : ''); }
        if (!forceDelayedSetToBeExecuted && this._lastBagTimemoutId) {
            clearTimeout(this._lastBagTimemoutId);
            this._lastBagTimemoutId = null;
        }

        if (delayMs)
            this._lastBagTimemoutId = setTimeout(f, Math.max(0, Math.min(15000, delayMs)));
        else
            f();
        return this;
    }
    setBooleanToBag(key: string, value: boolean, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        this.setToBag(key, value === true, delayMs, forceDelayedSetToBeExecuted);
        return this;
    }
    toggleBagBoolean(key: string, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        this.setToBag(key, !this.getBooleanFromBag(key), delayMs, forceDelayedSetToBeExecuted);
        return this;
    }

    updateBagWhere(whereClause: (key: string, val?: any) => boolean, value?: any) {
        if (whereClause)
            for (let k in this.bag)
                if (whereClause(k, this.bag[k]))
                    this.bag[k] = value;
    }
    updateBagWhereKeyStartWith(startWith: string, value?: any, excludedKeys?: string | string[]) {
        if (!startWith) return;
        excludedKeys = excludedKeys || [];
        if (!Array.isArray(excludedKeys))
            excludedKeys = [excludedKeys];
        const isExcluded = (x: string) => {
            if (x)
                for (let i = 0; i < excludedKeys.length; i++)
                    if (excludedKeys[i] === x)
                        return true;
            return false;
        };
        this.updateBagWhere(k => !isExcluded(k) && k.startsWith(startWith), value);
    }
    updateBag(updated?: common.IBag) {
        if (!updated)
            return this;
        var isUpdated = false;
        if (updated && updated.raw)
            for (let k in updated.raw) {
                this.bag[k] = updated.raw[k];
                if (!isUpdated)
                    isUpdated = true;
            }

        if (isUpdated)
            this.$forceUpdate();
        return this;
    }
    setManageButtonsOnFormModeChange(value: boolean) {
        this._manageButtonsOnFormModeChange = value !== false;
        return this;
    }

    private initConcurrencySumCheck(sumCheck?: string) {
        const f = this.formManager?.getFieldByName("ConcurrencySumCheck");
        if (f)
            f.setFromTextualValue(sumCheck || '');
        return this;
    }

    manageButtonsOnFormModeChange() {
        return this._manageButtonsOnFormModeChange !== false;
    }

    // setActionConfirmation(key: string, action?: () => void) {
    //     if (!key)
    //         throw "L'argument 'key' est NULL.";

    //     const f = this.formManager.getFieldByName(key);

    //     if (!f)
    //         throw "Le champ correspondant au nom '" + key + "' n'existe pas.";

    //     f.setFromTextualValue("true");

    //     if (action)
    //         this.$nextTick(action);

    //     return this;
    // }
    refreshEmbeddedComponents(urlParameters?: {}) {
        this.formManager?.refreshEmbeddedComponents(urlParameters);
    }
    refreshBrotherEmbeddedComponents() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager?.refreshBrotherEmbeddedComponents(name);
        return this;
    }
    restoreBrotherEmbeddedComponents() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager?.restoreBrotherEmbeddedComponents(name);
        return this;
    }
    ensureBrotherEmbeddedComponentsIsDefaultUrl() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager?.ensureBrotherEmbeddedComponentsIsDefaultUrl(name);
        return this;
    }
    refreshForceUpdate() {
        this.forceUpdate = utilities.createGuid("N");
    }
}

export = RecaptchaSecuriteVue;